import { render, staticRenderFns } from "./Vault3.vue?vue&type=template&id=40d72fc1&"
import script from "./Vault3.vue?vue&type=script&lang=js&"
export * from "./Vault3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports